export default __webpack_public_path__ + "static/VIRSAT@ADIPEC-85df56513648f83fba2ec569e02e568c.jpg";